import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8 12v3M8 1v3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.5 8a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M5.171 10.828L3.05 12.95m9.9-9.9l-2.122 2.122M4 8H1m14 0h-3M5.171 5.172L3.05 3.05m9.9 9.9l-2.122-2.122"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.757 16.242l-3.182 3.183m14.85-14.85l-3.182 3.183M6 12H1.5m21 0H18M7.757 7.758L4.575 4.575m14.85 14.85l-3.182-3.183"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.514 32.484L9.15 38.85m29.7-29.7l-6.365 6.366M12 24H3m42 0h-9m-20.486-8.484L9.15 9.15m29.7 29.7l-6.365-6.366"
  }))
};
export var Brightness = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});